import {
  FETCH_HOME_DETAILS_BEGIN,
  FETCH_HOME_DETAILS_SUCCESS,
  FETCH_HOME_DETAILS_FAILURE,
  FETCH_COMMON_DETAILS_BEGIN,
  FETCH_COMMON_DETAILS_SUCCESS,
  FETCH_COMMON_DETAILS_FAILURE
} from '../constants/homeActionTypes';

const initialState = {
  homeInfo: {
    banner: [],
    brands: [],
    categories: []
  },
  isFetching: false,
  contentLoaded: false,
  isLoading: true,
  error: {},
  commonDetails: []
}

export default function (state, action) {
  if (typeof state === 'undefined') {
    state = initialState;
  }
  switch (action.type) {
    case FETCH_HOME_DETAILS_BEGIN:
      return {
        ...state,
        isFetching: true,
        isLoading: true,
      };
    case FETCH_HOME_DETAILS_SUCCESS:
      return {
        ...state,
        homeInfo: action.payload,
        isFetching: false,
        contentLoaded: true,
        isLoading: false,
        error: null
      };
    case FETCH_HOME_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
        contentLoaded: true,
        isLoading: false
      };
    default:
      return state;
  }
}
